/* @jsx h */
import { defineComponent, onMounted, h } from "vue";
import { RouterView } from "vue-router";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { setTitle } from "@lemmonhq/orders";
export * from "./subpages/index";

export const CatalogEditorPage = defineComponent({
  name: "CatalogEditorPage",
  setup() {
    const { t } = useLocalization();
    onMounted(() => {
      setTitle("Catalog Editor");
    });

    return () => {
      const subpages = [
        {
          name: t("catalog.nav.overview"),
          icon: "space_dashboard",
          href: "/app/catalog_editor/overview",
        },
        {
          name: t("catalog.nav.services"),
          icon: "category",
          href: "/app/catalog_editor/services",
        },
        {
          name: t("catalog.nav.categories"),
          icon: "folder",
          href: "/app/catalog_editor/categories",
        },
        {
          name: t("catalog.nav.products"),
          icon: "inventory_2",
          href: "/app/catalog_editor/products",
        },
        {
          name: t("catalog.nav.extras"),
          icon: "add_circle",
          href: "/app/catalog_editor/extras",
        },
      ];

      return (
        <PageComponent
          title={t("catalog.nav.page_title")}
          titleIcon="category"
          subpages={subpages}
        >
          <RouterView />
        </PageComponent>
      );
    };
  },
});
